<div mat-dialog-title>
  <div>Select Other Programs</div>
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content class="content">
  <fc-program-list
    [regionId]="regionId"
    [selectedPrograms]="selectedPrograms"
    (selectedProgramsChange)="selectProgram($event)"></fc-program-list>
  <mat-divider></mat-divider>
  <div class="action-section">
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </div>
</div>
